import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from "@air/next-icons";
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import classNames from "classnames";
import { DROPDOWN_MENU_BASE_CLASS_NAME, dropdownMenu } from "./DropdownMenu";
import { DROPDOWN_MENU_ITEM_BASE_CLASS_NAME, dropdownMenuItem } from "./DropdownMenuItem";
export const DropdownMenuSub = (param)=>{
    let { children, className, defaultOpen, description, disabled, label, onOpenChange, open, prefix, size, suffix, "data-id": dataId, ...restOfProps } = param;
    const hasDescription = !!description;
    const isSmall = size === "small";
    return /*#__PURE__*/ _jsxs(RadixDropdownMenu.Sub, {
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        open: open,
        children: [
            /*#__PURE__*/ _jsxs(RadixDropdownMenu.SubTrigger, {
                className: size && size !== "small" ? dropdownMenuItem({
                    size
                }) : DROPDOWN_MENU_ITEM_BASE_CLASS_NAME,
                "data-testid": "DROPDOWN_MENU_SUB_TRIGGER",
                "data-id": dataId,
                disabled: disabled,
                children: [
                    prefix ? /*#__PURE__*/ _jsx("div", {
                        className: classNames("mr-2 flex shrink-0 items-center gap-1", hasDescription ? isSmall ? "mt-0.5" : "mt-1" : "mt-0"),
                        children: prefix
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex min-w-0 grow flex-col",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: classNames("truncate", isSmall ? "text-14" : "text-16"),
                                children: label
                            }),
                            hasDescription ? /*#__PURE__*/ _jsx("span", {
                                className: classNames("text-pigeon-500", isSmall ? "text-12" : "text-14"),
                                children: description
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: classNames("ml-2 flex shrink-0 items-center gap-1", hasDescription ? isSmall ? "mt-0.5" : "mt-1" : "mt-0"),
                        children: [
                            suffix,
                            /*#__PURE__*/ _jsx(ChevronRight, {
                                className: "size-4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(RadixDropdownMenu.Portal, {
                children: /*#__PURE__*/ _jsx(RadixDropdownMenu.SubContent, {
                    className: className || size && size !== "small" ? dropdownMenu({
                        className,
                        size
                    }) : DROPDOWN_MENU_BASE_CLASS_NAME,
                    "data-testid": "DROPDOWN_MENU_SUB",
                    ...restOfProps,
                    children: children
                })
            })
        ]
    });
};
